import { FaInstagram, FaFacebookF } from 'react-icons/fa';
import { HiHeart } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import siteContent from '../../data/siteContent.json';
import logo from '../../assets/images/grunge-bb-logo.png';

export default function Footer() {
  return (
    <footer className="bg-black text-white relative">
      {/* Lipstick pattern divider at top */}
      <div className="absolute top-0 left-0 right-0 h-1 opacity-20">
        <svg width="100%" height="100%" className="text-dusty-rose">
          <pattern id="lipstick-pattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <circle cx="20" cy="20" r="3" fill="currentColor" opacity="0.6" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#lipstick-pattern)" />
        </svg>
      </div>
      
      <div className="container-custom py-12 pt-14 relative z-10">
        <div className="flex flex-col items-center text-center space-y-10">
          {/* Brand Section */}
          <div className="max-w-md">
            <img
              src={logo}
              alt="Blush & Bobby"
              className="h-16 w-auto mb-6 mx-auto opacity-90"
            />
            <h4 className="font-headline text-sm uppercase tracking-wider mb-4 text-chalk">
              Contact Us
            </h4>
            <div className="flex flex-col items-center gap-y-2 text-dusty-rose/80 text-sm font-medium">
              <span>{siteContent.phone}</span>
              <a
                href={`mailto:${siteContent.email}`}
                className="hover:text-dusty-rose transition-colors"
              >
                {siteContent.email}
              </a>
              <Link
                to="/contact"
                className="mt-2 inline-flex items-center text-chalk hover:text-dusty-rose underline underline-offset-4 transition-colors"
              >
                Send us an inquiry
              </Link>
            </div>
          </div>

          {/* Socials */}
          <div className="flex flex-col items-center">
            <h4 className="font-headline text-sm uppercase tracking-wider mb-4 text-chalk">
              Follow Us
            </h4>
            <div className="flex space-x-6 mb-4">
              <a
                href={siteContent.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-dusty-rose/80 hover:text-dusty-rose transition-all hover:scale-110"
              >
                <FaInstagram className="h-6 w-6" />
              </a>
              <a
                href={siteContent.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-dusty-rose/80 hover:text-dusty-rose transition-all hover:scale-110"
              >
                <FaFacebookF className="h-6 w-6" />
              </a>
              <a
                href={siteContent.social.theKnot}
                target="_blank"
                rel="noopener noreferrer"
                className="text-dusty-rose/80 hover:text-dusty-rose transition-all hover:scale-110"
                title="The Knot"
              >
                <HiHeart className="h-6 w-6" />
              </a>
            </div>
            <p className="text-xs text-dusty-rose/60">
              Featured on The Knot & Wedding Wire
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-charcoal/30 mt-12 pt-8 text-center">
          <p className="text-dusty-rose/40 text-[10px] uppercase tracking-widest">
            &copy; {new Date().getFullYear()} Blush & Bobby. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
